import {Offer, OfferStorage} from "../domain";

const getSelectedProductVariantId = (offer: Offer, addedOffers: OfferStorage[]) => {
  const addedOffer = addedOffers.find((o) => o.offerId === offer.id);
  if (addedOffer) {
    offer.shopify_product_variant_id = addedOffer.productVariantId;
    offer.shopify_product_handle = addedOffer.productHandle;
    const product = offer.products?.find(
      (p) => p.shopify_product_handle === addedOffer.productHandle,
    );
    offer.shopify_product_variants = product
      ? product.shopify_product_variants
      : [];
    return addedOffer.productVariantId;
  }
}


export default getSelectedProductVariantId
